import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./TrainingUserNeedElement.css";

function TrainingUserNeedElement({
  id,
  firstName,
  lastName,
  profileName,
  profileName_english,
  count,
}) {
  return (
    <Col key={id} className="training-user-need-element">
      <Row className="justify-content-center align-items-center">
        <Col lg={10}>
          <h6>
            {firstName} {lastName}
          </h6>
          <p>{profileName}</p>
        </Col>
        <Col lg={2} className="center">
          <p>{count}</p>
        </Col>
      </Row>
    </Col>
  );
}

export default TrainingUserNeedElement;
